
import { useEffect, useState } from "react";
import { EntityQuery, is, LegalPerson, LinkedEntityQuery, Query, RelationshipDirection, Subsidiary, from } from "@the-real-insight/tri-model";
import { userAPI } from "../UserAPI";
import InfoList from "./InfoList";
import { useTranslation } from "react-i18next";
import { legalPersonCompanyName, legalPersonPostalLine } from "../utilities/legalPersonDisplay";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface Properties {
  legalPerson?: LegalPerson;
  processError?: (error: any) => void;
}

export default function LegalPersonProperties(properties: Properties) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const [legalPerson, setLegalPerson] = useState() as any;

  const setParams = (value: any) => {
    console.log('Value >>>', value);

    const url = new URL(window.location.href);

    url.searchParams.set('tab', value);
    window.history.replaceState(null, '', url.toString());

    setTab(value);
  };

  useEffect(() => {
    const entity = properties.legalPerson;
    if (!entity?._id) {
      return;
    }

    const legalPersonId = `${entity._id}`;

    const call = async () => {
      const legalPerson: any = await userAPI.queryOne(from(LegalPerson.type).where(
        is('_id').equal(legalPersonId),
      ));

      console.log('Legal person >>>', legalPerson);

      setLegalPerson(legalPerson);

      const legalPersonWithSubsidiaries: any = await userAPI.queryOne(new Query(new EntityQuery(LegalPerson.type, [], undefined,
        // @ts-ignore
        is('_id').equal(legalPersonId)), [new LinkedEntityQuery('subsidiaries', RelationshipDirection.out, Subsidiary.type)]));

      if (legalPersonWithSubsidiaries) {
        console.log('Legal persons >>>', legalPersonWithSubsidiaries);

        setLegalPerson({ ...legalPerson, subsidiaries: legalPersonWithSubsidiaries.subsidiaries });
      }
    };

    call();
  }, [properties]);

  return (legalPerson
    ?
    <div className="flex min-w-0 max-w-[1400px] flex-col gap-4">
      <div className="min-w-0">
        <p className="text-sm text-muted-foreground">Company</p>
        <h2 className="mt-0.5 break-words text-xl font-bold leading-tight text-[color:var(--customer-primary-dark,hsl(var(--foreground)))] sm:text-2xl">
          {legalPersonCompanyName(legalPerson)}
        </h2>
      </div>
      {/* `tab` startet wie im Bestand auf 0 und trifft damit keinen Reiter —
          erst ein Klick wählt einen aus. Unverändert übernommen. */}
      <Tabs value={String(tab)} onValueChange={setParams} className="min-w-0">
        <TabsList className="max-sm:[&_[role=tab]]:min-h-[44px]">
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="subsidiaries">Niederlassungen</TabsTrigger>
          <TabsTrigger value="management">{t('ui.management')}</TabsTrigger>
        </TabsList>
        <TabsContent value="general" className="mt-4">
          <InfoList list={[{
            label: t('legalPersonPropertiesPanel.purpose'),
            value: legalPerson.purpose,
          }, {
            label: t('legalPersonPropertiesPanel.headquarters'),
            value: legalPersonPostalLine(legalPerson),
          }, {
            label: t('legalPersonPropertiesPanel.founded'),
            value: (() => {
              if (!legalPerson.started) return '-';
              const date = new Date(legalPerson.started);
              return isNaN(date.getTime()) ? '-' : date.toLocaleDateString();
            })(),
          }, {
            label: t('legalPersonPropertiesPanel.tradeRegisterId'),
            value: legalPerson.tradeRegisterId,
          }, {
            label: t('legalPersonPropertiesPanel.tradeRegisterCity'),
            value: legalPerson.tradeRegisterCity,
          }, {
            label: t('legalPersonPropertiesPanel.website'),
            value: legalPerson.website ? legalPerson.website : '-',
            link: legalPerson.website,
          },
          ]} valueWidth="350px"></InfoList>
        </TabsContent>
        <TabsContent value="subsidiaries" className="mt-4">
          {legalPerson.subsidiaries && legalPerson.subsidiaries.length > 0
            ?
            <></>
            :
            <p className="text-sm text-muted-foreground">Keine Daten zu Niederlassungen verfügbar.</p>
          }
        </TabsContent>
        <TabsContent value="management" className="mt-4">
          {legalPerson.generalManagers && legalPerson.generalManagers.length > 0
            ?
            <></>
            :
            <p className="text-sm text-muted-foreground">{t('ui.noManagementData')}</p>
          }
        </TabsContent>
      </Tabs>
    </div>
    :
    <></>
  );
}
